import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import * as Api from "../../../appApi/AppApi";

const TAG = "carrierGetRejectedBrands.js";

function* workerCarrierGetRejectedBrands(payLoad) {
  console.log(TAG, "get rejected brands : " + JSON.stringify(payLoad));
  try {
    const response = yield call(
      Api.makeSecuredPostRequest,
      API_ENDPOINT.GET_REJECTED_BRANDS , payLoad.data
    );
    yield put(memberAction.carrierGetRejectedBrandsSuccess(response));
  } catch (error) {
    console.error(TAG, "Worker get rejected brands failed: " + error.message);
    // yield put(memberAction.deleteUserFailed(error.message));
    // throw new Error("Error: inside saga", JSON.stringify(error));
  }
}

export const watchCarrierGetRejectedBrands = takeLatest(
  memberType.CARRIER_GET_REJECTED_BRANDS_REQESTED,
  workerCarrierGetRejectedBrands
);
